module.exports = __webpack_public_path__ + "static/media/7.407c3934.jpeg";